import { ShieldCheck, Users, CalendarDays } from "lucide-react";

interface MicroTrustProps {
  /** Visual alignment */
  align?: "center" | "left";
  /** Use light text on dark backgrounds (e.g. hero) */
  variant?: "default" | "onDark";
  className?: string;
}

/**
 * Tiny trust line shown right under primary CTAs.
 * "С 1993 года · Более 1000 клиентов · Без предоплаты"
 * Reused everywhere to keep messaging consistent.
 */
const MicroTrust = ({ align = "center", variant = "default", className = "" }: MicroTrustProps) => {
  const color =
    variant === "onDark"
      ? "text-primary-foreground/85"
      : "text-muted-foreground";
  const justify = align === "left" ? "justify-start" : "justify-center";

  const items = [
    { icon: CalendarDays, text: "С 1993 года" },
    { icon: Users, text: "Более 1000 клиентов" },
    { icon: ShieldCheck, text: "Без предоплаты" },
  ];

  return (
    <ul
      className={`flex flex-wrap items-center ${justify} gap-x-3 gap-y-1 text-[11px] md:text-[12px] font-medium ${color} ${className}`}
      aria-label="Гарантии"
    >
      {items.map(({ icon: Icon, text }, i) => (
        <li key={text} className="flex items-center gap-1.5">
          <Icon className="h-3 w-3 md:h-3.5 md:w-3.5 opacity-80" strokeWidth={2.2} />
          <span>{text}</span>
          {i < items.length - 1 && (
            <span className="opacity-40 ml-1.5 hidden sm:inline">·</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MicroTrust;
